var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnlargeButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3677_72528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82644 10.1724C5.73267 10.0787 5.60552 10.026 5.47294 10.026C5.34036 10.026 5.2132 10.0787 5.11944 10.1724L1.02344 14.2684V11.5004C1.02344 11.3678 0.970759 11.2406 0.876991 11.1468C0.783223 11.0531 0.656046 11.0004 0.523437 11.0004C0.390829 11.0004 0.263652 11.0531 0.169884 11.1468C0.0761159 11.2406 0.0234375 11.3678 0.0234375 11.5004V15.4754C0.0234375 15.608 0.0761159 15.7352 0.169884 15.8289C0.263652 15.9227 0.390829 15.9754 0.523437 15.9754H4.49844C4.63105 15.9754 4.75822 15.9227 4.85199 15.8289C4.94576 15.7352 4.99844 15.608 4.99844 15.4754C4.99844 15.3428 4.94576 15.2156 4.85199 15.1218C4.75822 15.0281 4.63105 14.9754 4.49844 14.9754H1.73044L5.82644 10.8794C5.92017 10.7856 5.97283 10.6585 5.97283 10.5259C5.97283 10.3933 5.92017 10.2662 5.82644 10.1724ZM10.1704 5.82839C10.2642 5.92213 10.3914 5.97478 10.5239 5.97478C10.6565 5.97478 10.7837 5.92213 10.8774 5.82839L14.9734 1.73239V4.50039C14.9734 4.633 15.0261 4.76018 15.1199 4.85394C15.2137 4.94771 15.3408 5.00039 15.4734 5.00039C15.606 5.00039 15.7332 4.94771 15.827 4.85394C15.9208 4.76018 15.9734 4.633 15.9734 4.50039V0.525391C15.9734 0.392782 15.9208 0.265605 15.827 0.171837C15.7332 0.078069 15.606 0.0253906 15.4734 0.0253906H11.4984C11.3658 0.0253906 11.2387 0.078069 11.1449 0.171837C11.0511 0.265605 10.9984 0.392782 10.9984 0.525391C10.9984 0.657999 11.0511 0.785176 11.1449 0.878944C11.2387 0.972712 11.3658 1.02539 11.4984 1.02539H14.2664L10.1704 5.12139C10.0767 5.21515 10.024 5.34231 10.024 5.47489C10.024 5.60747 10.0767 5.73463 10.1704 5.82839Z",
    fill: "#DFDFDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3677_72528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlargeButton);
export default __webpack_public_path__ + "static/media/enlargeButton.81d7443648ffac1e84ef623569d8baa9.svg";
export { ForwardRef as ReactComponent };